<template>
  <ais-sort-by :items="sortByOptions">
    <template #default="{ items, currentRefinement, refine }">
      <ul>
        <li v-for="item in items" :key="item.value" class="filter-label">
          <a
            href="#"
            :class="{
              active: item.value === currentRefinement,
            }"
            :style="{
              fontWeight: item.value === currentRefinement ? 'bold' : 'normal',
            }"
            @click.prevent="onRefine(item, refine)"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
    </template>
  </ais-sort-by>
</template>

<script>
import { AisSortBy } from 'vue-instantsearch';
import SortBy from '../../mixins/SortBy';

export default {
  components: {
    AisSortBy,
  },
  mixins: [SortBy],
  methods: {
    onRefine(item, refine) {
      this.$emit('filter-update');
      refine(item.value);
    },
  },
};
</script>
